import * as React from 'react';
import {Fragment, ReactElement} from 'react';
import {Datagrid, EditButton, List, ListProps, useTranslate} from 'react-admin';
import {Route} from 'react-router';

import VideoCategoryFilter from "./VideoCategoryFilter";
import VideoCategoryEdit from "./VideoCategoryEdit";
import SideDrawer from "../../components/list/SideDrawer";
import TextField from "../../components/list/TextField";
import ListActions from "../../components/list/ListActions";
import {Typography} from "@material-ui/core";


const VideoCategoryList = (props: ListProps): ReactElement => {
    const translate = useTranslate();

    return (
        <Fragment>
            <Typography variant={'h6'}>{translate('resources.admin/videos.name')}</Typography>
            <List {...props} filters={<VideoCategoryFilter/>} sort={{field: 'id', order: 'DESC'}} actions={<ListActions/>}>
                <Datagrid>
                    <TextField source="id"/>
                    <TextField source="name"/>
                    <EditButton/>
                </Datagrid>
            </List>
            <Route path={`${props.basePath}/:id`}>
                {({match}) => {
                    const isMatch = (match && match.params && match.params.id !== 'create');
                    return (
                        <SideDrawer open={!!isMatch} basePath={props.basePath ?? ''}>
                            {isMatch && (
                                <VideoCategoryEdit id={match && isMatch ? match.params.id : undefined}{...props}/>
                            )}
                        </SideDrawer>
                    );
                }}
            </Route>
        </Fragment>
    );
};

export default VideoCategoryList;
